module.exports = __webpack_public_path__ + "719f7321a8366f4ee609737026432113.woff";


//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui/dist/fonts/open-sans-semibold-italic.woff
// module id = 1545
// module chunks = 0